<template>
  <component
    :is="dynamicButtonComponent"
    :color="errors.length > 0 ? 'error' : 'primary'"
    @click="$emit('click:openDialog')"
  >
    <template #tooltip>
      <slot name="tooltip" />
    </template>
  </component>
</template>

<script>
import genericPickerProps from "@/components/global_components/pickers/generic_picker/mixins/generic-picker-props";

export default {
  name: "DefaultGenericPicker",
  mixins: [genericPickerProps],
  computed: {
    dynamicButtonComponent() {
      if (this.buttonComponent) {
        return this.buttonComponent;
      }
      return 'w-link-button';
    }
  },
}
</script>
